import React, { Component } from 'react'
import fp from 'lodash/fp'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import FilterBar from './components/filter-bar'
import { API_PENDING, API_SUCCESS, API_FAIL } from 'redux/api/constants'
import { Col, Row, Spinner, TextInput, Button, Checkbox, Select } from 'elements'
import { liveVisitListSelector, faceCheckinsSelector,  liveVisitListStatusSelector, siteListSelector, holdersCountSelector, liveDiscoverySelector, clientConfigDetailsSelector } from 'redux/selectors'
import { jsonToQueryString, parseQueryString } from 'utils/helpers'
import { listFaceCheckins } from 'redux/modules/model/face'
import { logUserTab } from 'redux/modules/user/index'
import { withClientId } from 'hocs'
import { listSites, listenToSubscriptions } from 'redux/modules/model/site';
import { getClientConfig } from 'redux/modules/model/client'
import { getActiveHoldersCount } from 'redux/modules/model/holder';

import Timeline, { TodayMarker, TimelineMarkers, TimelineHeaders, DateHeader, SidebarHeader } from 'react-calendar-timeline'
import 'react-calendar-timeline/lib/Timeline.css'
import moment from 'moment-timezone';
import { Avatar, Typography } from '@/elements';
import { PageContentUnderTitle } from 'components'
import ZoneFilter from './components/zone-filter';

import './index.scss'

const COMPONENT_CSS_CLASSNAME = 'directory-filter-bar'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

const { Title } = Typography;

const predicate = (criteria) => (item) => {
  if (criteria.search) {
    const ucSearch = criteria.search.toUpperCase()
    return item.name.toUpperCase().includes(ucSearch) ||
      item.username.toUpperCase().includes(ucSearch) ||
      item.email.toUpperCase().includes(ucSearch)
  }
  if (!criteria.showAll) {
    return item.active
  }
  return true
}

class FaceVisitsList extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    logUserTab: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    livevisitList: PropTypes.array.isRequired,
    liveVisitListStatus: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props)
    this.state = {
      search: null,
      siteId: null,
      openCheckin: false,
      queryParams: {
        ...parseQueryString(this.props.location.search),
        showAll: '1'
      }
    }
  }

  groupRenderer = ({ group }) => {
    return <div className="tip">
      <section className="containerr">
        <div className="one"><Avatar className="image"
          image={group.image}
        /></div>
        <div className="two"><p>{group.title}</p><p>{group.id}</p></div>
      </section>

    </div>;
  };

  componentDidMount() {
    const { clientId, logUserTab, listSites, getClientConfig, getActiveHoldersCount } = this.props
    listSites({ clientId });
    getClientConfig({ targetClientId: clientId })
    getActiveHoldersCount({ clientId });
    const tab = "faceVisits"
    logUserTab({ clientId, tab })
  }

  componentDidUpdate(prevProps, prevState) {
    const { siteId, zoneId } = this.state;
    const { sitesList, clientId, getZonesList, zonesList, listenToSubscriptions, discoveredList, listFaceCheckins } = this.props;
    if (prevProps.discoveredList.length > 0 && discoveredList.length > 0)
      for (var m = 0; m < discoveredList.length; m++) {
        if (prevProps.discoveredList[m] && discoveredList[m])
          if (prevProps.discoveredList[m].detectionTime !== discoveredList[m].detectionTime) {
            listFaceCheckins({ clientId, siteId })
          }
      }

    if (siteId && prevState.siteId !== siteId) {
      listFaceCheckins({ clientId, siteId })
      listenToSubscriptions({
        clientId,
        siteId,
        includeLastKnown: true,
      });
    }
    if (sitesList && sitesList.length > 0 && !siteId) {
      this.handleSiteChange(sitesList[0].siteId);
    }
  }

  setURLHref = (params) => {
    const { history } = this.props
    history.push({
      location: ROUTES.DIRECTORY,
      search: jsonToQueryString(params),
      showAll: params.showAll
    })
  };

  handleSearchChange = e => {
    this.setState({
      search: e.target.value,
    });
    const params = {
      ...parseQueryString(location.search),
      search: e.target.value,
    };
    this.setURLHref(params);
    this.setState({ queryParams: params });
  };

  handleSiteChange = siteId => {
    const newQueryStr = {
      ...this.state.queryParams,
      site: encodeURIComponent(siteId),
    };
    this.setURLHref(newQueryStr);
    this.setState({ queryParams: newQueryStr, siteId });
  };

  handleShowAllSites = () => {
    var siteId = "all"
    const newQueryStr = {
      ...this.state.queryParams,
      site: encodeURIComponent(siteId),
    };
    this.setURLHref(newQueryStr);
    this.setState({ queryParams: newQueryStr, siteId });
  }

  handleActiveChange = (e) => {
    const params = {
      ...this.state.queryParams,
      showAll: e
    }
    this.setURLHref(params)
  }

  render() {
    const { livevisitList, liveVisitListStatus, location, sitesList, holdersCountList, discoveredList, facecheckinsList,  clientId, clientConfigDetail } = this.props
    console.log("🚀 ~ file: index.js ~ line 166 ~ FaceVisitsList ~ render ~ facecheckinsList", facecheckinsList)
    const {
      queryParams: { zone: zoneId, site: siteId, thermal: thermalId },
    } = this.state;
    let membersOptionsList = [
      { name: 'show all', id: '1' },
      { name: 'checked in', id: '2' },
      { name: 'checked out', id: '3' }]

    const params = parseQueryString(location.search)
    let search = params.search
    let showAll = location.showAll
    let memberId = location.showAll
    const { view = 'list' } = params
    let groups = []
    let items = []
    var counter = 0
    var todayCounter = 0
    let clientReferences = []
    let checkedinClientReferences = []
    facecheckinsList.forEach((liveVisit, i) => {
      if (liveVisit.endTime === null) {
        checkedinClientReferences.push(liveVisit.clientReference)
      }
    })
    // if (clientConfigDetail) {
    //   if (clientConfigDetail.clientId === clientId && clientConfigDetail.liveVisitMergePeriod !== 0) {
    //     for (let i = livevisitList.length - 1; i >= 0; i--) {
    //       for (let j = i - 1; j >= 0; j--) {
    //         if (livevisitList[i].clientReference === livevisitList[j].clientReference && livevisitList[i].siteId === livevisitList[j].siteId) {
    //           const currentEndTime = new Date(livevisitList[i].endTime);
    //           const previousStartTime = new Date(livevisitList[j].startTime);
    //           const diffTime = (Math.abs(previousStartTime - currentEndTime)) / 1000;
    //           if (diffTime < clientConfigDetail.liveVisitMergePeriod) {
    //             livevisitList[j].startTime = livevisitList[i].startTime
    //             livevisitList.splice(i, 1);
    //           }
    //         }
    //       }
    //     }
    //   }
    // }
    facecheckinsList.forEach((liveVisit, i) => {
      var inputDate = new Date(liveVisit.startTime);

      var todaysDate = new Date();

      var endTime = liveVisit.endTime;
      var colour = '#ff9800'
      if (endTime === null) {
        counter++
        endTime = new Date()
        endTime = moment(endTime).format()
        colour = '#1dc992'
      }
      var startTime = liveVisit.startTime;
      endTime = moment(endTime).tz("Europe/London").format()
      startTime = moment(startTime).tz("Europe/London").format()
      var inputDate1 = new Date(endTime);

      var found2 = false
      for (var j = 0; j < clientReferences.length; j++) {
        if (clientReferences[j] === liveVisit.clientReference) {
          found2 = true;
          break;
        }
      }
      if (!found2) {
        if (inputDate.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0) ||
          inputDate1.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
          clientReferences.push(liveVisit.clientReference)
          todayCounter++
        }
      }
      if (showAll === '1') {
        var found = false;
        for (var k = 0; k < groups.length; k++) {
          if (groups[k].id == liveVisit.clientReference) {
            found = true;
            break;
          }
        }
        if (!found) {
          if (liveVisit.name.toUpperCase().includes((search || "").toUpperCase()) || !search) {
            groups.push({
              id: liveVisit.clientReference,
              title: liveVisit.name,
              stackItems: true,
              image: liveVisit.imagePath,
              tip: liveVisit.clientReference
            })
          }
        }
        items.push({
          id: i,
          group: liveVisit.clientReference,
          title: `${startTime.substr(11, 5)} - ${endTime.toString().substr(11, 5)} - ${siteId === 'all' ? liveVisit.siteId : siteId}`,
          start_time: new Date(startTime),
          end_time: new Date(endTime),
          itemProps: {
            style: {
              background: colour
            }
          }
        })
      } else if (showAll === '2') {
        if (liveVisit.endTime === null) {
          var found = false;
          for (var k = 0; k < groups.length; k++) {
            if (groups[k].id == liveVisit.clientReference) {
              found = true;
              break;
            }
          }
          if (!found) {
            if (liveVisit.name.toUpperCase().includes((search || "").toUpperCase()) || !search) {
              groups.push({
                id: liveVisit.clientReference,
                title: liveVisit.name,
                stackItems: true,
                image: liveVisit.imagePath,
                tip: liveVisit.clientReference
              })
            }
          }
          items.push({
            id: i,
            group: liveVisit.clientReference,
            title: `${startTime.substr(11, 5)} - ${endTime.toString().substr(11, 5)} - ${siteId === 'all' ? liveVisit.siteId : siteId}`,
            start_time: new Date(startTime),
            end_time: new Date(endTime),
            itemProps: {
              style: {
                background: colour
              }
            }
          })
        }

      } else if (showAll === '3') {
        if (liveVisit.endTime && !checkedinClientReferences.includes(liveVisit.clientReference)) {
          var found = false;
          for (var k = 0; k < groups.length; k++) {
            if (groups[k].id == liveVisit.clientReference) {
              found = true;
              break;
            }
          }
          if (!found) {
            if (liveVisit.name.toUpperCase().includes((search || "").toUpperCase()) || !search) {
              groups.push({
                id: liveVisit.clientReference,
                title: liveVisit.name,
                stackItems: true,
                image: liveVisit.imagePath,
                tip: liveVisit.clientReference
              })
            }
          }
          items.push({
            id: i,
            group: liveVisit.clientReference,
            title: `${startTime.substr(11, 5)} - ${endTime.toString().substr(11, 5)} - ${siteId === 'all' ? liveVisit.siteId : siteId}`,
            start_time: new Date(startTime),
            end_time: new Date(endTime),
            itemProps: {
              style: {
                background: colour
              }
            }
          })
        }
      }

    });
    return (
      <div>
        <Row gutter={40} align="middle" justify="center" >
          <Col xs={32} md={16}>
            <ZoneFilter
              onZoneChange={this.handleSiteChange}
              zoneId={siteId}
              zones={sitesList}
              placeholder="Select a site"
              idKey="siteId"
              nameKey="description"
            />
          </Col>
          <Col xs={14} md={8}>
            <Button
              className="all-sites-button"
              type="primary"
              onClick={this.handleShowAllSites}
            >
              All sites
            </Button>
          </Col>
        </Row>
        <Row gutter={40} align="middle" justify="center" >
          <Col xs={32} md={16}>
            <Select
              showSearch
              value={memberId}
              style={{ width: '100%' }}
              placeholder={"Select members"}
              optionFilterProp="children"
              onChange={this.handleActiveChange}
              className="select-members"
            >
              {membersOptionsList.map((membersOption) => (
                <Select.Option value={membersOption['id']} key={membersOption['id']}>
                  {membersOption['name']}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col xs={14} md={8}>
            <FilterBar setURLHref={this.setURLHref} onSearchChange={this.handleSearchChange} />
          </Col>
        </Row>
        <Row gutter={40} align="middle" justify="center" className="row-counters">
          <Col xs={12} md={7}>
            <button className="unifi-button-counter">
              Total number of members: {holdersCountList.length}
            </button>
          </Col>
          <Col xs={20} md={9}>
            <button className="unifi-button-counter">
              {siteId === 'all' ? `Total members currently in all sites: ${counter}` : `Total members currently on site: ${counter}`}
            </button>
          </Col>
          <Col xs={14} md={8}>
            <button className="unifi-button-counter">
              {siteId === 'all' ? `Total members today in all sites: ${todayCounter}` : `Total members today: ${todayCounter}`}
            </button>
          </Col>
        </Row>
        <Timeline
          groups={groups}
          items={items}
          defaultTimeStart={moment().add(-12, 'hour')}
          defaultTimeEnd={moment().add(12, 'hour')}
          groupRenderer={this.groupRenderer}
          sidebarWidth={250}
          lineHeight={70}>
          <TimelineHeaders>
            <SidebarHeader>
              {({ getRootProps }) => {
                return <div className="sidebar" {...getRootProps()}>Members</div>
              }}
            </SidebarHeader>
            <DateHeader unit="primaryHeader" />
            <DateHeader />
          </TimelineHeaders>
          <TimelineMarkers>
            <TodayMarker />
          </TimelineMarkers>
        </Timeline>
      </div>
    )
  }
}

export const selector = createStructuredSelector({
  livevisitList: liveVisitListSelector,
  facecheckinsList: faceCheckinsSelector,
  liveVisitListStatus: liveVisitListStatusSelector,
  clientConfigDetail: clientConfigDetailsSelector,
  sitesList: siteListSelector,
  holdersCountList: holdersCountSelector,
  discoveredList: liveDiscoverySelector,
})

export const actions = {
  listFaceCheckins,
  logUserTab,
  listSites,
  getClientConfig,
  getActiveHoldersCount,
  listenToSubscriptions
}

export default compose(
  withRouter,
  withClientId,
  connect(selector, actions),
)(FaceVisitsList)



// WEBPACK FOOTER //
// ./src/pages/face-visits/facevisit-list/index.js